exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".basicModal.body{padding:21px 40px}@media only screen and (max-width:767px){.basicModal.body{padding:10px 12px}}", ""]);

// exports
